import { lazy } from 'react';

const AsyncRadioClipList = lazy(() => import('./ListContainer'));

export const RadioClipList = () => {
  return <AsyncRadioClipList />;
};
